import { html, css } from 'lit-element';
import { compose } from 'redux';
import { TmnButtonListToolBase } from '@trumedianetworks/tmn-core-components/src/tmn-tool-base';
import '@trumedianetworks/tmn-core-components/src/tmn-icon';
import '@trumedianetworks/tmn-core-components/src/tmn-button';
import '@trumedianetworks/tmn-core-components/src/tmn-grid';
import { connect } from '../store/connect';
import { selectors, actions } from '.';

class AccountMenu extends TmnButtonListToolBase {
    constructor() {
        super();
        this.icon = 'cloud_download';
    }
    //LinkStyles.styles,
    static get styles() {
        return [
            super.styles,
            css`
                tmn-modal {
                    color: var(--app-on-surface-color);
                    top: 90%;
                    left: unset;
                    right: 0;
                    min-width: 150px;
                }
                tmn-routed-button,
                tmn-button {
                    color: var(--app-on-surface-color);
                }
                tmn-routed-link,
                tmn-button {
                    width: 100%;
                }
                .userName {
                    color: var(--app-on-primary-color);
                    /* background: var(--menu-select-color); */
                    background: var(--app-primary-color);
                    padding: 8px;
                    margin: -2px;
                }
            `,
        ];
    }

    static get properties() {
        return {
            userAccount: {
                type: Object,
            },
        };
    }

    renderButton() {
        return html`
            <tmn-icon-button @click="${this._toggleDialog}">
                <tmn-icon icon="account_circle" iconvariant="outlined" color="primary"></tmn-icon>
            </tmn-icon-button>
        `;
    }

    renderToolTitle() {
        const { userAccount } = this;
        const { displayName } = userAccount;
        return html` <span class="userName" slot="title">${displayName}</span> `;
    }

    renderButtonList() {
        const useEndIcon = false;
        return html`
            <tmn-button
                .justifyContent=${'flex-start'}
                @click=${this.logout}
                variant="text"
                .endIconEnabled=${useEndIcon}>
                <tmn-icon slot="startIcon" icon="exit_to_app"></tmn-icon>
                Logout</tmn-button
            >
        `;
    }
    //     <tmn-routed-link name="settings" .isTopNav=${true}>
    //     <tmn-button
    //         .justifyContent=${'flex-start'}
    //         @click=${this.handleSettingsClick}
    //         variant="text"
    //         .endIconEnabled=${useEndIcon}>
    //         <tmn-icon slot="startIcon" icon="settings"></tmn-icon>
    //         ${localize('Settings')}
    //     </tmn-button>
    // </tmn-routed-link>
    // <tmn-routed-link name="tools">
    //     <tmn-button
    //         .justifyContent=${'flex-start'}
    //         @click=${this.handleSettingsClick}
    //         variant="text"
    //         .endIconEnabled=${useEndIcon}>
    //         <tmn-icon slot="startIcon" icon="handyman"></tmn-icon>
    //         ${localize('Tools')}
    //     </tmn-button>
    // </tmn-routed-link>
    logout() {
        this.actions.logout();
    }

    handleSettingsClick() {
        // require b/c routed link does preventdefault
        this.open = false;
    }
}

const mapStateToProps = (state, ownProps) => {
    const userAccount = selectors.userAccountSelector(state);
    return {
        userAccount,
    };
};

window.customElements.define(
    'account-menu',
    compose(connect(mapStateToProps, actions))(AccountMenu)
);
